"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var UserTypeEntity_1 = __importDefault(require("./Entity/UserTypeEntity"));
var UserTypeApi = /** @class */ (function () {
    function UserTypeApi(session) {
        this.userTypeEntity = new UserTypeEntity_1.default(session);
    }
    UserTypeApi.prototype.get = function (id) {
        return this.userTypeEntity.getUserType(id);
    };
    UserTypeApi.prototype.getAll = function () {
        return this.userTypeEntity.getAllUserTypes();
    };
    UserTypeApi.prototype.update = function (id, userType) {
        return this.userTypeEntity.updateUserType(id, userType);
    };
    UserTypeApi.prototype.create = function (userType) {
        return this.userTypeEntity.createUserType(userType);
    };
    return UserTypeApi;
}());
exports.default = UserTypeApi;
//# sourceMappingURL=UserTypeApi.js.map